import { useAnimatedNumber } from "@/hooks/useAnimatedNumber";
import { Skeleton } from "@/components/ui/skeleton";

export default function StatCard({
  n,
  value,
  label,
  suffix = "",
  loading = false,
}) {
  const animated = useAnimatedNumber(value || 0);

  return (
    <div className="card p-6">
      <div className="font-mono text-xs text-zinc-500 mb-6">{n}</div>

      {loading ? (
        <Skeleton className="h-8 w-20 mb-2" />
      ) : (
        <div className="font-display text-3xl sm:text-4xl font-medium tracking-tight tabular-nums">
          {animated.toLocaleString()}
          {suffix}
        </div>
      )}

      <div className="text-sm text-zinc-600 mt-2 leading-relaxed">{label}</div>
    </div>
  );
}
